import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class RequiredContexts extends BaseRootOption {
  static userInterfaceComponent = () => {
    return {
      useCustomLabel: true,
      useVerticalOrientation: true,
      label: "Required Contexts",
      component: inspectorTools.REQUIRED_CONTEXTS,
    };
  };

  static defaultValue = {};
}
